import { render } from "./model_ethan.vue?vue&type=template&id=a74be7f6"
import script from "./model_ethan.vue?vue&type=script&lang=js"
export * from "./model_ethan.vue?vue&type=script&lang=js"

import exportComponent from "/Users/voltz/Documents/Github/Website/virtualhumans/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__